module.exports = __webpack_public_path__ + "static/media/blurred-background.1469add0.jpg";